import { ApiResponse } from "../../../services/models";
import { IFilterGroup } from "../../../data";
import { IMultipleEntities } from "../../../base/types";
import { rootApi } from "../../../services/rootApi";

export interface ICalendarDataQuery {
  entity?: string,
  select?: string[],
  filters?: IFilterGroup[]
  expand?: string
  expandFilters?: string
}

const calendarDataApi = rootApi.injectEndpoints({
  overrideExisting: false,

  endpoints: builder => ({
    readCalendarData: builder.query<IMultipleEntities, ICalendarDataQuery>({
      query: (options) => ({
        url: `/Calendar`,
        headers: { 'info-query': JSON.stringify(options) }
      }),
      transformResponse: (res: ApiResponse) => {
        return JSON.parse(res.value) as IMultipleEntities;
      }
    })
  })
})

export const {
  useReadCalendarDataQuery,
  useLazyReadCalendarDataQuery,
} = calendarDataApi;